/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("GradingMatrixEditController", function GradingMatrixEditController(
	$scope,
	$rootScope,
	$routeParams,
	$route,
	$location,
	$filter,
	$document,
	$timeout,

	dxRubricsRepository,
	GradingMatrix,
	dxSession,
	DX_URLS,
	dxLocalize,
	focus,
	dxEvent,

	dxDialog,
	dxAngularConstantHelper
) {
	"use strict";

	$scope.reqs = {
		matrix: false,
	};

	var matrixId = parseInt($routeParams.id, 10) || 0;
	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	$scope.state = {
		isSaving: false,
		// $scope.$watch will trigger the listener one time after binding it
		// so we want to skip that first autosave.
		skipNextMatrixWatch: true,
	};

	$scope.matrix = new GradingMatrix();
	$scope.dxSession = dxSession;
	$scope.loading = true;

	$scope.showHelp = false;

	var lastRoute = $route.current;
	var preventReload = false;

	$scope.$on("$locationChangeSuccess", function onLocationChangeSuccess() {
		if (preventReload) {
			$route.current = lastRoute;
			preventReload = false;
		}
	});

	$scope.loadDraft = function loadDraft() {
		return dxRubricsRepository.loadDraft(matrixId).then(function success(draft) {
			if (draft != null) { // eslint-disable-line eqeqeq, no-eq-null
				$scope.draft = draft;
				return $scope.confirmLoadDraft();
			}

			$scope.reqs.matrix = true;
			return $scope.startMatrixWatcher();
		});
	};

	$scope.confirmLoadDraft = function confirmLoadDraft() {
		// Ask the user if he/she wants to use or discard the available draft.
		dxDialog.confirm({
			title: dxLocalize.get("LoadDraft"),
			body: draftDialogBodyText(),
			acceptText: dxLocalize.get("LoadDraft"),
			acceptCallback: $scope.useDraft,
			rejectText: dxLocalize.get("NoDiscardDraft"),
			rejectCallback: $scope.discardDraft,
		});
	};

	function draftDialogBodyText() {
		var text;
		if ($scope.draft.title === "") {
			text = dxLocalize.get("NamelessRubric");
		} else {
			text = $scope.draft.title;
		}
		return dxLocalize.get("LoadDraftExplanation").format(text, $filter("date")(new Date($scope.draft.updated), "yyyy-MM-dd HH:mm"));
	}

	$scope.useDraft = function useDraft() {
		$scope.matrix = $scope.draft;
		$scope.reqs.matrix = true;
		$scope.startMatrixWatcher();
		dxDialog.closeMostRecent();
	};

	$scope.discardDraft = function discardDraft() {
		function confirmDiscardDraft() {
			dxRubricsRepository.saveDraft(matrixId, "").then(function success() {
				dxDialog.closeMostRecent();
				$scope.reqs.matrix = true;
				$scope.startMatrixWatcher();
			});
		}

		return dxDialog.confirm({
			title: dxLocalize.get("AreYouReallySure"),
			body: dxLocalize.get("Action.CannotBeUndone"),
			acceptText: dxLocalize.get("Confirm"),
			acceptCallback: confirmDiscardDraft,
			rejectText: dxLocalize.get("Cancel"),
			rejectCallback: $scope.confirmLoadDraft,
		});
	};

	function isTitleUnique() {
		for (var i = 0; i < dxRubricsRepository.items.length; i++) {
			var matrix = dxRubricsRepository.items[i];
			if ((matrix.title === $scope.matrix.title && dxSession.getUser().id === matrix.userId) && (matrix.id !== $scope.matrix.id)) {
				return false;
			}
		}
		return true;
	}

	$scope.saveAsNew = function saveAsNew() {
		var scope = $rootScope.$new();
		scope.item = {};
		scope.items = dxRubricsRepository.items;
		scope.item.title = "";
		scope.errorMessage = "ThereIsAlreadyARubricWithThatTitle";
		scope.saveAsNew = function saveAsNewFunc(title) {
			$scope.matrix.title = title;
			return $scope.save(true);
		};

		dxDialog.show({
			templateUrl: "partials/popups/save-as-new.html",
			$scope: scope,
		});
	};

	$scope.save = function save(saveAsOriginal, closeOnSave) {
		if (saveAsOriginal == null) { // eslint-disable-line eqeqeq, no-eq-null
			saveAsOriginal = false; // eslint-disable-line no-param-reassign
		}

		if (!$scope.matrix.isValid() || $scope.state.isSaving) {
			return;
		}

		if (!isTitleUnique()) {
			$scope.errorMessage = "ThereIsAlreadyARubricWithThatTitle";
			return;
		}

		$scope.errorMessage = "";
		$scope.state.isSaving = true;

		if ($scope.autosaveTimeout) {
			$timeout.cancel($scope.autosaveTimeout);
		}

		var originalMatrixId = $scope.matrix.id;
		if (saveAsOriginal) {
			$scope.matrix.id = 0;
		}

		dxRubricsRepository.save($scope.matrix).then(function success(updatedMatrix) {
			$scope.state.isSaving = false;
			$scope.saveMessage = dxLocalize.get("Feedback.Saved.1:Time", $filter("date")(new Date(), "HH:mm:ss"));
			// Assigning the updated matrix will trigger an autosave that we do not want.
			$scope.state.skipNextMatrixWatch = true;
			$scope.matrix = angular.copy(updatedMatrix);

			// Remove the draft because its changes has now been saved properly
			dxRubricsRepository.saveDraft(originalMatrixId, "");

			if (closeOnSave) {
				$location.path(DX_URLS.get("rubrics"));
				return;
			}

			if ($scope.matrix.id !== originalMatrixId) {
				preventReload = true;
				$location.path(DX_URLS.get("rubricEdit", $scope.matrix));
				$location.replace();
			}
		}, function failed() {
			$scope.state.isSaving = false;
			$scope.matrix.id = originalMatrixId;
			$rootScope.$broadcast("notification:error", "Could not save matrix. Try again or contact support.");
		});
	};

	$scope.startMatrixWatcher = function startMatrixWatcher() {
		return $scope.$watch("matrix", $scope.matrixWatcherCallback, true);
	};

	$scope.matrixWatcherCallback = function matrixWatcherCallback() {
		$scope.errors = [];
		$scope.matrix.isValid($scope.errors);

		if (!$scope.state.skipNextMatrixWatch) {
			$scope.delayAutosaveDraft();
		}

		$scope.state.skipNextMatrixWatch = false;
	};

	$scope.delayAutosaveDraft = function delayAutosaveDraft() {
		if ($scope.autosaveTimeout) {
			$timeout.cancel($scope.autosaveTimeout);
		}

		$scope.autosaveTimeout = $timeout($scope.autosaveDraft, 3000, false);
	};

	$scope.autosaveDraft = function autosaveDraft() {
		if ($scope.matrix.userId === dxSession.getUser().id) {
			$scope.state.skipNextMatrixWatch = true;
			$scope.matrix.updated = new Date();
			dxRubricsRepository.saveDraft($scope.matrix.id, angular.toJson($scope.matrix)).then(function success() {
				$scope.saveMessage = dxLocalize.get("Feedback.DraftSaved.1:Time", $filter("date")(new Date(), "HH:mm:ss"));
			});
		}
	};

	$scope.autosaveDraftNow = function autosaveDraftNow() {
		if ($scope.autosaveTimeout) {
			$timeout.cancel($scope.autosaveTimeout);
			$scope.autosaveDraft();
		}
	};

	$scope.confirmDelete = function confirmDelete(item, type) {
		if (!(item && (type === "grade" || type === "ability"))) {
			return;
		}

		// We must do this because we can't pass the item on to
		// the confirm callback directly from the confirm popup
		// without first setting the item on the scope anyways...
		$scope.itemToDelete = item;
		$scope.itemToDeleteType = type;

		// Skip the confirmation if the item and related criteria does not have any data
		if (!(item.title || item.description || $scope.criteriaHasDescription(type, item.id))) {
			$scope.deleteItem();
			return;
		}

		var bodyText;
		var confirmText;
		var titleText;

		if (type === "grade") {
			titleText = "RemoveGrade";
			bodyText = "WarningWhenRemovingRubricGrade";
			confirmText = "RemoveGrade";
		} else {
			titleText = "RemoveAbility";
			bodyText = "WarningWhenRemovingRubricAbility";
			confirmText = "RemoveAbility";
		}

		dxDialog.confirm({
			actionIsDangerous: true,
			title: dxLocalize.get(titleText) + (item.title ? ' "' + item.title + '"' : ""),
			body: dxLocalize.get(bodyText),
			acceptText: dxLocalize.get(confirmText),
			acceptCallback: $scope.deleteItem,
			rejectText: dxLocalize.get("Cancel"),
			rejectCallback: $scope.abortDeleteItem,
		});
	};

	$scope.abortDeleteItem = function abortDeleteItem() {
		$scope.itemToDelete = null;
		dxDialog.closeMostRecent();
	};

	$scope.deleteItem = function deleteItem() {
		if ($scope.itemToDelete) {
			$scope.onDeleteFocusUpdate($scope.itemToDelete, $scope.itemToDeleteType);
			$scope.matrix.remove($scope.itemToDelete);
			$scope.itemToDelete = null;
			$scope.itemToDeleteType = null;
		}

		dxDialog.closeMostRecent();
	};

	$scope.onDeleteFocusUpdate = function onDeleteFocusUpdate(item, type) {
		var focusItem = $scope.matrix.nextSiblingFor(item);
		if (focusItem == null) { // eslint-disable-line eqeqeq, no-eq-null
			focusItem = $scope.matrix.prevSiblingFor(item);
		}

		var focusName = type + "-";
		if (focusItem != null) { // eslint-disable-line eqeqeq, no-eq-null, no-negated-condition
			focusName += focusItem.id;
		} else {
			focusName += "create";
		}

		return focus(focusName);
	};

	$scope.criteriaHasDescription = function criteriaHasDescription(associatedType, associatedId) {
		return $scope.matrix.criteria.some(function some(criterion) {
			return criterion[associatedType + "Id"] === associatedId && criterion.description;
		});
	};

	$scope.addAbility = function addAbility() {
		var ability = $scope.matrix.addAbility();
		$scope.autofocusAbility = ability.id;
		return dxEvent.create(DX_EVENT_NAME.EventCreateRubricAbilityAdded);
	};

	$scope.addGrade = function addGrade() {
		var grade = $scope.matrix.addGrade();
		$scope.autofocusGrade = grade.id;
	};

	function hideHelpPopup(event) {
		if (!event.isPropagationStopped()) { // eslint-disable-line no-negated-condition
			$scope.$apply(function apply() {
				$scope.showHelp = false;
			});
		} else {
			$scope.showHelp = false;
		}
		// Remove click listener after use. This prevents memory leak.
		$document.off("click", hideHelpPopup);
	}

	$scope.toggleHelpPopup = function toggleHelpPopup($event) {
		$event.stopPropagation();

		if ($scope.showHelp) {
			hideHelpPopup($event);
		} else {
			$scope.showHelp = true;
			$document.on("click", hideHelpPopup);
		}
	};

	// Initialize
	if (matrixId === 0) {
		$scope.loadDraft();
		$scope.loading = false;
	} else {
		dxRubricsRepository.load(matrixId, false).then(function success(matrix) {
			$scope.matrix = angular.copy(matrix);
			if ($scope.matrix.userId === dxSession.getUser().id) {
				$scope.loadDraft();
			} else {
				$scope.reqs.matrix = true;
				$scope.startMatrixWatcher();
			}

			$scope.loading = false;
		});
	}

	return dxEvent.create(DX_EVENT_NAME.PageviewCreateRubric);
});
